export const environment = {
  production: false,
  apiUrl: 'https://api-dev.atlantisapp.cl',
  baseUrl: 'https://dev.atlantisapp.cl'
};
